import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchWarehouseDashboardData } from 'components/Apis/warehouse';
import { fetchWarehouseStatus, fetchWarehouseData } from 'components/Apis/warehouse';

export const updateWarehouseData = createAsyncThunk(
  'warehouse/updateWarehouseData',
  async (_, { getState, rejectWithValue }) => {
    const { display, warehouse, filters, sort } = getState().warehouse;
    try {
      return await fetchWarehouseData(display, warehouse, filters, sort);
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching warehouse data');
    }
  }
);

export const getWarehouseStatus = createAsyncThunk(
  'warehouse/getWarehouseStatus',
  async (_, { getState, rejectWithValue }) => {
    const { warehouse } = getState().warehouse;
    try {
      // setWarhouseStatusToInitialState()
      return await fetchWarehouseStatus(warehouse);
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching warehouse status');
    }
  }
);

export const getWarehouseDashboard = createAsyncThunk(
  'warehouse/getWarehouseDashboard',
  async (timeRange, { getState, rejectWithValue }) => {
    const { warehouse } = getState().warehouse;
    try {
      return await fetchWarehouseDashboardData(timeRange, warehouse);
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching warehouse dashboard');
    }
  }
);

const warehouseSlice = createSlice({
  name: "warehouse",
  initialState: {
    display: "Dashboard",
    warehouse: "Laredo",
    loading: false,
    error: null,
    traffic: {
      incoming_orders: [],
      outgoing_orders: [],
      incoming_buses: [],
      outgoing_buses: [],
      incoming_partials: [],
      outgoing_partials: [],
    },
    warehouseStatus: {
      incoming_orders_count: null,
      outgoing_orders_count: null,
      late_pickups: 0,
      on_dock: 0,
      scanned_count: 0,
      discrepancies: 0,
      last_audit: {
        date: "",
        auditor: "",
      }
    },
    modalStates: {
      partialCreator: {
        orderId: null,
        showModal: false
      },
    },
    dashboardData: {
      bol_errors: [],
      buses_incoming: [],
      buses_outgoing: [],
      loading_times: { loading: [], unloading: [] },
      orders_incoming: [],
      orders_outgoing: [],
      trailers: [],
      button_titles: {},
    },
    filters: {
      searchText: "",
      orderType: "all",
    },
    sort: {
      column: null,
      direction: "+",
    }
  },
  reducers: {
    changeDisplay: (state, action) => {
      state.display = action.payload;
    },
    changeWarehouse: (state, action) => {
      state.warehouse = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setSort: (state, action) => {
      const column = action.payload;
      console.log(column)
      if (state.sort.column === column) {
        state.sort.direction = state.sort.direction === "+" ? "-" : "+";
      }
      state.sort.column = column;
    },
    setShowReduxModal: (state, action) => {
      state.modalStates = { ...state.modalStates, ...action.payload };
    },
    resetWarehouseState: (state) => {
      Object.assign(state, warehouseSlice.getInitialState());
    }
  },
  extraReducers: (builder) => {
    builder
      // traffic
      .addCase(updateWarehouseData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateWarehouseData.fulfilled, (state, action) => {
        state.traffic = action.payload;
        state.loading = false;
      })
      .addCase(updateWarehouseData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // status
      .addCase(getWarehouseStatus.pending, (state) => {
        state.error = null;
      })
      .addCase(getWarehouseStatus.fulfilled, (state, action) => {
        state.warehouseStatus = action.payload;
      })
      .addCase(getWarehouseStatus.rejected, (state, action) => {
        state.error = action.payload;
      })
      // dashboard
      .addCase(getWarehouseDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getWarehouseDashboard.fulfilled, (state, action) => {
        state.dashboardData = action.payload;
        state.loading = false;
      })
      .addCase(getWarehouseDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const {
  changeDisplay,
  changeWarehouse,
  setFilters,
  setSort,
  setShowReduxModal,
  resetWarehouseState
} = warehouseSlice.actions;

export default warehouseSlice.reducer;